import React, { useState } from "react";
import {
  field, footerMail,
  emailInput, consentContainer,
  consentCheckbox, successMsg, box, text
} from "./style.mod.scss";
import locale from "locales";
import ArrowRight from "assets/svgs/arrow-right.svg";
import TickIcon from "assets/svgs/tick.svg";
import { Formik, Field, Form } from "formik";
import { loadRecaptcha } from "helpers/load-recaptcha";
import { trackSignUp, trackEmailAddress } from "helpers/analytics";
import hashEmailAddress from "helpers/hash-email-address";

const ActiveCampaignForm = ({ displayCheckbox }) => {
  const [submitted, setSubmitted] = useState(false);
  const handleSubscribe = async ({ email }) => {
    window.grecaptcha.ready(async function () {
      await window.grecaptcha.execute(process.env.GATSBY_RECAPTCHA_SITE_KEY, { action: "submit" });

      const response = await fetch("/.netlify/functions/klaviyo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        }
      );

      if (response?.status === 204) {
        setSubmitted(locale.account.waitingList.joinedWaitingList);
      }

    });
    trackSignUp("newsletter", "email address");
    const hashedEmail = await hashEmailAddress(email);
    trackEmailAddress(hashedEmail);
  };

  return (
    <div className={field} id="activeCampaignForm">
      <Formik
        initialValues={{ email: "" }}
        onSubmit={handleSubscribe}
      >

        {({ isSubmitting, handleChange }) => (
          <Form>
            {!submitted &&
              <>
                <div className={footerMail}>
                  <Field className={emailInput} onChange={handleChange} onFocus={loadRecaptcha} name="email" placeholder={locale.footer.yourEmail} />
                  <button type="submit" disabled={isSubmitting} id="submitForm"> <ArrowRight /> </button>
                </div>
                {(displayCheckbox || displayCheckbox === undefined) && (
                  <div className={consentContainer}>
                    <input className={consentCheckbox} id="checkbox" type="checkbox" />
                    <label htmlFor="checkbox"> {locale.footer.agreeCheckbox} </label>
                  </div>
                )}
              </>
            }
            {submitted && <div className={successMsg}>
              <div className={box}>
                <TickIcon />
                <div className={text}>
                  <p style={{ fontWeight: "bold" }}>{locale.footer.thankYouTitle}</p>
                  <p>{locale.footer.thankYouBody}</p>
                </div>
              </div>
            </div>}
          </Form>
        )}
      </Formik>
    </div>
  );
};


export default ActiveCampaignForm;
